import { applicationSlice } from './Application/ApplicationSlice.js'
import { authenticationSlice } from './Authentication/AuthenticationSlice.js'
import { billingSlice } from './Billing/BillingSlice.js'
import { invitationSlice } from './Invitation/InvitationSlice.js'
import { orderSlice } from './Order/OrderSlice.js'
import { organizationSlice } from './Organization/OrganizationSlice.js'
import { projectSlice } from './Project/ProjectSlice.js'
import { otuSlice } from './Otu/OtuSlice.js'
import { tourSlice } from './Tour/TourSlice.js'
import { modalSlice } from './ModalSlice/ModalSlice.js'
import { visualizationSlice } from './Visualization/VisualizationSlice.js'
import { chatSlice } from './Chat/ChatSlice.js'
import { adminSpinSlice } from './AdminSpin/AdminSpinSlice.js'
import { orderWizardActions, orderWizardSlice } from './OrderWizard/OrderWizardSlice.ts'
import { spinStatusSlice } from './Spin/SpinStatusSlice.ts'
import { spinMetaSlice } from './Spin/SpinMetaSlice.ts'

export type ArrayElement<ArrayType extends readonly unknown[]> = ArrayType extends readonly (infer ElementType)[] ? ElementType : never

export const Slices = [
  applicationSlice,
  authenticationSlice,
  billingSlice,
  invitationSlice,
  orderSlice,
  organizationSlice,
  projectSlice,
  otuSlice,
  tourSlice,
  modalSlice,
  chatSlice,
  adminSpinSlice,
  orderWizardSlice,
  spinStatusSlice,
  spinMetaSlice
] as const

export const Actions = {
  [applicationSlice.name]: { ...applicationSlice.actions },
  [authenticationSlice.name]: { ...authenticationSlice.actions },
  [billingSlice.name]: { ...billingSlice.actions },
  [invitationSlice.name]: { ...invitationSlice.actions },
  [orderSlice.name]: { ...orderSlice.actions },
  [organizationSlice.name]: { ...organizationSlice.actions },
  [projectSlice.name]: { ...projectSlice.actions },
  [otuSlice.name]: { ...otuSlice.actions },
  [tourSlice.name]: { ...tourSlice.actions },
  [visualizationSlice.name]: { ...visualizationSlice.actions },
  [chatSlice.name]: { ...chatSlice.actions },
  [adminSpinSlice.name]: { ...adminSpinSlice.actions },
  [orderWizardSlice.name]: { ...orderWizardActions },
  [spinStatusSlice.name]: { ...spinStatusSlice.actions },
  [spinMetaSlice.name]: { ...spinMetaSlice.actions }
}

export const State = {
  [applicationSlice.name]: applicationSlice.getInitialState(),
  [authenticationSlice.name]: authenticationSlice.getInitialState(),
  [billingSlice.name]: billingSlice.getInitialState(),
  [invitationSlice.name]: invitationSlice.getInitialState(),
  [orderSlice.name]: orderSlice.getInitialState(),
  [organizationSlice.name]: organizationSlice.getInitialState(),
  [projectSlice.name]: projectSlice.getInitialState(),
  [otuSlice.name]: otuSlice.getInitialState(),
  [tourSlice.name]: tourSlice.getInitialState(),
  [modalSlice.name]: modalSlice.getInitialState(),
  [visualizationSlice.name]: visualizationSlice.getInitialState(),
  [chatSlice.name]: chatSlice.getInitialState(),
  [adminSpinSlice.name]: adminSpinSlice.getInitialState(),
  [orderWizardSlice.name]: orderWizardSlice.getInitialState(),
  [spinStatusSlice.name]: spinStatusSlice.getInitialState(),
  [spinMetaSlice.name]: spinMetaSlice.getInitialState()
}

export const Reducer = {
  [applicationSlice.name]: applicationSlice.reducer,
  [authenticationSlice.name]: authenticationSlice.reducer,
  [billingSlice.name]: billingSlice.reducer,
  [invitationSlice.name]: invitationSlice.reducer,
  [orderSlice.name]: orderSlice.reducer,
  [organizationSlice.name]: organizationSlice.reducer,
  [projectSlice.name]: projectSlice.reducer,
  [otuSlice.name]: otuSlice.reducer,
  [tourSlice.name]: tourSlice.reducer,
  [modalSlice.name]: modalSlice.reducer,
  [visualizationSlice.name]: visualizationSlice.reducer,
  [chatSlice.name]: chatSlice.reducer,
  [adminSpinSlice.name]: adminSpinSlice.reducer,
  [orderWizardSlice.name]: orderWizardSlice.reducer,
  [spinStatusSlice.name]: spinStatusSlice.reducer,
  [spinMetaSlice.name]: spinMetaSlice.reducer
}
